import { Button, Divider, Form, Input, notification, Select } from 'antd';
import React from 'react';
import { useUpdateStatusMediasToQualify } from '../../../../../utils/api/medias/useUpdateStatusMediasToQualify';
import { REJECTION_REASONS } from '../../../../../utils/const/medias';
import {
  editionActionButtonStyle,
  editionActionsInnerStyle,
  editionActionsRowStyle,
} from './editionActionsLayout';

const { TextArea } = Input;

const RejectedReasonPanel = ({ setHasRejectedMedias, selectedMedias }) => {
  const [form] = Form.useForm();
  const { updateStatusMediasToQualify } = useUpdateStatusMediasToQualify();

  const handleReject = async () => {
    try {
      const values = await form.validateFields();

      let payloadReason = values.reason;
      if (values.reason === 'Autre (préciser dans le commentaire)') {
        payloadReason = values.comment;
      }

      const payload = {
        status: 'rejected',
        reason: payloadReason,
        comment: values.comment || '',
        mediaIds: selectedMedias.map((m) => m.id),
      };
      const result = await updateStatusMediasToQualify(payload);
      if (result?.errors?.length > 0) {
        throw new Error(result.errors.map((e) => e.error).join('; '));
      }

      notification.success({
        message: 'Médias rejetés',
        description: 'Les médias ont été rejetés avec succès',
        placement: 'bottomRight',
        duration: 3,
      });

      setHasRejectedMedias(false);
    } catch (e) {
      if (e.errorFields) {
        return;
      }
      notification.error({
        message: 'Erreur de refus des médias',
        description: `Les médias n'ont pas pu être refusés : ${e}`,
        placement: 'bottomRight',
        duration: 3,
      });
    }
  };

  const handleCancel = () => {
    setHasRejectedMedias(false);
  };

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          padding: '16px',
          borderBottom: '1px solid #f0f0f0',
          backgroundColor: '#fafafa',
        }}
      >
        <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600 }}>
          Motif du rejet
        </h3>
      </div>

      <div style={{ flex: 1, overflow: 'auto', padding: '16px' }}>
        <Form form={form} layout="vertical">
          <Form.Item
            label="Raison du refus"
            name="reason"
            rules={[
              {
                required: true,
                message: 'Veuillez sélectionner une raison',
              },
            ]}
          >
            <Select
              placeholder="Sélectionner une raison"
              options={REJECTION_REASONS.map((r) => ({ label: r, value: r }))}
            />
          </Form.Item>

          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.reason !== currentValues.reason
            }
          >
            {({ getFieldValue }) => {
              const reason = getFieldValue('reason');
              const isOtherReason =
                reason === 'Autre (préciser dans le commentaire)';

              return (
                <Form.Item
                  label="Commentaire"
                  name="comment"
                  rules={[
                    {
                      required: isOtherReason,
                      message:
                        'Le commentaire est obligatoire pour cette raison',
                    },
                  ]}
                >
                  <TextArea
                    rows={4}
                    placeholder={
                      isOtherReason
                        ? 'Commentaire obligatoire'
                        : 'Ajouter un commentaire, si nécessaire'
                    }
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Form>

        <Divider style={{ margin: '24px 0 16px' }} />

        <div style={editionActionsRowStyle}>
          <div style={editionActionsInnerStyle}>
            <Button
              block
              style={editionActionButtonStyle}
              onClick={handleCancel}
            >
              Annuler
            </Button>
            <Button
              type="primary"
              block
              style={editionActionButtonStyle}
              onClick={handleReject}
            >
              Rejeter
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectedReasonPanel;
